import React, { useEffect, useState } from "react";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { useAddVendorMutation } from "features/vendor/vendorSlice";
import NotificationProvider from "components/NotificationProvider";
import CustomInput from "components/CustomInput";
import { Grid } from "@material-ui/core";

const VendorConfig = ({ setOpen, open, vendor }) => {
    const [emailReminderIntervalDays, setEmailReminderIntervalDays] = useState(vendor?.emailReminderIntervalDays);
    const [addVendor, { isLoading: isAdding }] = useAddVendorMutation();

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = async () => {
        let res = await addVendor({ ...vendor, emailReminderIntervalDays: emailReminderIntervalDays });
        if (!res?.error) {
            NotificationProvider.success('Successfully updated vendor');
        } else {
            NotificationProvider.error('Failed to update vendor');
            onCancel()
        }
        handleClose();
    };

    const onCancel = () => {
        handleClose();
        setEmailReminderIntervalDays(vendor?.emailReminderIntervalDays);
    }

    return (
        <Dialog open={open} aria-labelledby="form-dialog-title">
            <DialogContent>
                <Grid container direction="row" spacing={2} alignItems="center">
                    <Grid item xs={8}><b>Email Reminder Interval Days:</b></Grid>
                    <Grid item xs={4}>
                        <CustomInput
                            id="emailReminderIntervalDays"
                            numberOnly
                            elementType="input"
                            value={emailReminderIntervalDays}
                            variant="outlined"
                            onChange={e => setEmailReminderIntervalDays(e)}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    Cancel
                </Button>
                <Button
                    onClick={handleSave}
                    color="primary"
                    variant="contained"
                    disabled={isAdding}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};


export default VendorConfig;
